import React, { isValidElement, PureComponent } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { Icon } from '@qnpm/q-theme';
import { qAccessibilityLabel, logEvent, QavEvent, commonUtil } from '@qnpm/q-design-utils';
import { CheckBox } from '@qnpm/q-components';
import { Tips } from '@qnpm/q-tips';
import WeekHeader from '../Calendar/components/WeekHeader';
import NavibarStyle from './styles';
const hitSlop = { left: 8, top: 8, right: 8, bottom: 8 };
export default class Navibar extends PureComponent {
    constructor(props) {
        super(props);
        this.styles = new NavibarStyle(false);
        this.state = {
            isDirectSelected: props.checkedDirect
        };
    }
    componentDidMount() {
        const { hasDirect, tipsContent, accessibilityPreName } = this.props;
        hasDirect &&
            logEvent(new QavEvent({
                page: accessibilityPreName,
                model: 'float_calendar_nav_bar',
                action: 'show_direct_button',
                attributes: {
                    operTime: Date.now()
                }
            }));
        commonUtil.isValidArray(tipsContent) &&
            logEvent(new QavEvent({
                page: accessibilityPreName,
                model: 'float_calendar_nav_bar',
                action: 'show_tips',
                attributes: {
                    operTime: Date.now()
                }
            }));
    }
    render() {
        const styles = this.styles.getStyle();
        const { title = '', needScale, accessibilityPreName, onFloatClose, hasDirect, tipsContent, weekData, computedStyle, showWeekHeader, dynamicHeaderView, tipsWrapperCustomStyle } = this.props;
        return (<>
                <View style={styles.header}>
                    <View style={styles.headerContent}>
                        <Text {...qAccessibilityLabel(`${accessibilityPreName}CalendarNavibar#title`)} style={styles.headerText}>
                            {title}
                        </Text>
                    </View>
                    {!hasDirect ? null : this.renderDirect()}
                    <TouchableOpacity style={styles.icon} hitSlop={hitSlop} onPress={onFloatClose}>
                        <Icon name="close" size={18} needScale={needScale}/>
                    </TouchableOpacity>
                </View>
                
                {isValidElement(dynamicHeaderView) ? dynamicHeaderView : null}
                {tipsContent ? (<Tips tipList={tipsContent} customStyle={tipsWrapperCustomStyle}/>) : null}
                
                {showWeekHeader ? (<WeekHeader computedStyle={computedStyle} data={weekData}/>) : null}
            </>);
    }
    renderDirect() {
        const styles = this.styles.getStyle();
        const { directTitle } = this.props;
        return (<TouchableOpacity style={styles.directContent} hitSlop={hitSlop} activeOpacity={0.8} onPress={() => {
            this.toggleDirect();
        }}>
                <CheckBox text={directTitle} selected={this.state.isDirectSelected} type="grayEmpty" size={{ height: 16, width: 16 }} onPress={() => {
            this.toggleDirect();
        }}/>
                <Text style={styles.directText}>{directTitle}</Text>
            </TouchableOpacity>);
    }
    toggleDirect() {
        const { onDirectHandler, accessibilityPreName } = this.props;
        const checked = !this.state.isDirectSelected;
        this.setState({ isDirectSelected: checked });
        onDirectHandler && onDirectHandler(checked);
        logEvent(new QavEvent({
            page: accessibilityPreName,
            model: 'float_calendar_nav_bar',
            action: (checked ? 'checked' : 'unchecked') + '_direct_option',
            attributes: {
                operTime: Date.now()
            }
        }));
    }
}
Navibar.defaultProps = {
    accessibilityPreName: '',
    directTitle: '只看直飞',
    needScale: false,
    onDirectHandler: () => { }
};
